import { RSAA } from "redux-api-middleware";
import { BASE_URL } from "../api/endpoints";

export default () => {
  return async (dispatch: any, getState: any) => {
    const state = getState();
    const customer_id = state.general.merchants.selectedMerchant
      ? state.general.merchants.selectedMerchant.customer_id
      : "";
    const selectedYear = state.general.year.selectedYear;
    dispatch({
      [RSAA]: {
        endpoint: `${BASE_URL}/api/v1/customer_reports/customers_list?tax_year=${selectedYear}&merchant_id=${customer_id}`,
        method: "GET",
        headers: { "Content-Type": "application/json" },
        types: [
          "CUSTOMER_LIST_REQUEST",
          "CUSTOMER_LIST_SUCCESS",
          "CUSTOMER_LIST_ERROR",
        ],
      },
    });
  };
};
